export default () => {
  return new Promise(resolve => {
    navigator.mediaDevices.getUserMedia({ audio: true })
      .then(stream => {
        const mediaRecorder = new MediaRecorder(stream)
        const audioChunks = []

        mediaRecorder.addEventListener('dataavailable', event => {
          audioChunks.push(event.data)
        })

        const start = () => {
          mediaRecorder.start()
        }
        const stop = () => {
          return new Promise(resolve => {
            mediaRecorder.addEventListener('stop', () => {
              const audioBlob = new Blob(audioChunks)
              const audioUrl = URL.createObjectURL(audioBlob)
              const element = new Audio(audioUrl)

              resolve({ audioBlob, audioUrl, element })
            })

            mediaRecorder.stop()
          })
        }

        resolve({ start, stop })
      })
  })
}
